import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-video-recorder-config-view',
  standalone: true,
  templateUrl: './video-recorder-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoRecorderConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
